import(/* webpackMode: "eager", webpackExports: ["TopNavigationWrapper"] */ "/app/apps/pickleball/src/modules/top-navigation/TopNavigationWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.3.3_@babel+core@7.28.0_@opentelemetry+api@1.9.0_@playwright+test@1.51.0_react-d_b4015b36f71207b40b648e466e346c67/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/src/components/advertisements/components/advertisement-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainHeader"] */ "/app/packages/ui/src/components/global/Header/MainHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/src/components/global/platformStatsFooter/PlatformStatsFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/src/components/global/platformStatsFooter/PlatformStatsFooterSkeleton.tsx");
